/**
 * Enlaces del sitio principal (bikerentmallorca.com) por idioma.
 * Cada enlace puede tener una URL distinta para es, en y de.
 * Modifica las URLs según las rutas reales de cada idioma en el sitio.
 */

const BASE = 'https://bikerentmallorca.com';
const BASE_EN = 'https://bikerentmallorca.com/en';
const BASE_DE = 'https://bikerentmallorca.com/de';

export const SITE_LINKS = {
  // --- Header ---
  'header.home': {
    es: `${BASE}/`,
    en: `${BASE_EN}/`,
    de: `${BASE_DE}/`,
  },
  'header.rental': {
    es: `${BASE}/alquiler-de-bicicletas/`,
    en: `${BASE_EN}/bike-rental-mallorca/`,
    de: `${BASE_DE}/fahrradverleih/`,
  },
  'header.tours': {
    es: `${BASE}/tours-en-bicicleta/`,
    en: `${BASE_EN}/bike-tours/`,
    de: `${BASE_DE}/fahrradtouren/`,
  },
  'header.delivery': {
    es: `${BASE}/entrega-en-hoteles/`,
    en: `${BASE_EN}/hotel-delivery/`,
    de: `${BASE_DE}/lieferdienst-an-hotels/`,
  },
  'header.accessories': {
    es: `${BASE}/extras-y-accesorios/`,
    en: `${BASE_EN}/extras-and-accessories/`,
    de: `${BASE_DE}/extras-und-zubehoer/`,
  },
  'header.contact': {
    es: `${BASE}/contacto/`,
    en: `${BASE_EN}/contact/`,
    de: `${BASE_DE}/kontakt/`,
  },

  // --- Footer: Empresa ---
  'footer.company.bikes': {
    es: `${BASE}/alquiler-de-bicicletas/`,
    en: `${BASE_EN}/bike-rental-mallorca/`,
    de: `${BASE_DE}/fahrradverleih/`,
  },
  'footer.company.jetski': {
    es: `${BASE}/monkey-on-tours/`,
    en: `${BASE_EN}/monkey-on-tours-en/`,
    de: `${BASE_DE}/monkey-on-tours-de/`,
  },
  'footer.company.buggy': {
    es: `${BASE}/monkey-on-tours/`,
    en: `${BASE_EN}/monkey-on-tours-en/`,
    de: `${BASE_DE}/monkey-on-tours-de/`,
  },
  'footer.company.parasailing': {
    es: `${BASE}/monkey-on-tours/`,
    en: `${BASE_EN}/monkey-on-tours-en/`,
    de: `${BASE_DE}/monkey-on-tours-de/`,
  },
  'footer.company.workshop': {
    es: `${BASE}/taller-bicicletas/`,
    en: `${BASE_EN}/bike-services-cala-millor/`,
    de: `${BASE_DE}/fahrradwerkstatt/`,
  },

  // --- Footer: Enlaces rápidos ---
  'footer.quick.rental': {
    es: `${BASE}/alquiler-de-bicicletas/`,
    en: `${BASE_EN}/bike-rental-mallorca/`,
    de: `${BASE_DE}/fahrradverleih/`,
  },
  'footer.quick.tours': {
    es: `${BASE}/tours-en-bicicleta/`,
    en: `${BASE_EN}/bike-tours/`,
    de: `${BASE_DE}/fahrradtouren/`,
  },
  'footer.quick.hotels': {
    es: `${BASE}/entrega-en-hoteles/`,
    en: `${BASE_EN}/hotel-delivery/`,
    de: `${BASE_DE}/lieferdienst-an-hotels/`,
  },
  'footer.quick.extras': {
    es: `${BASE}/extras-y-accesorios/`,
      en: `${BASE_EN}/extras-and-accessories/`,
      de: `${BASE_DE}/extras-und-zubehoer/`,
  },
  'footer.quick.routes': {
    es: `${BASE}/rutas-bicicletas-mallorca/`,
    en: `${BASE_EN}/bike-routes-cala-millor/`,
    de: `${BASE_DE}/fahrradrouten-in-der-naehe/`,
  },

  // --- Footer: Sobre la tienda ---
  'footer.about.contact': {
    es: `${BASE}/contacto/`,
    en: `${BASE_EN}/contact/`,
    de: `${BASE_DE}/kontakt/`,
  },
  'footer.about.us': {
    es: `${BASE}/sobre-nosotros/`,
    en: `${BASE_EN}/sobre-nosotros/`,
    de: `${BASE_DE}/ueber-uns/`,
  },
  'footer.about.gallery': {
    es: `${BASE}/galeria/`,
    en: `${BASE_EN}/gallery/`,
    de: `${BASE_DE}/galerie/`,
  },
  'footer.about.legal': {
    es: `${BASE}/aviso-legal/`,
    en: `${BASE_EN}/legal-notice/`,
    de: `${BASE_DE}/impressum/`,
  },
  'footer.about.cookies': {
    es: `${BASE}/cookies/`,
    en: `${BASE_EN}/cookies-en/`,
    de: `${BASE_DE}/cookies-de/`,
  },
};

/**
 * Devuelve la URL del enlace para el idioma dado.
 * @param {string} linkId - Clave del enlace (ej: 'header.home', 'footer.quick.rental')
 * @param {string} language - Código de idioma ('es' | 'en' | 'de')
 * @returns {string} URL del enlace
 */
export function getSiteLink(linkId, language) {
  const urls = SITE_LINKS[linkId];
  if (!urls) return '#';
  return urls[language] ?? urls.es ?? '#';
}
